export const data = {
  en: [
    {
      title: 'Shipping & Delivery',
      questions: [
        {
          q: 'Can I order from your branches through delivery apps?',
          a: 'Yes, you can order directly through the following apps: Jahez, The Chefs',
        },
        {
          q: 'Is shipping available outside Saudi Arabia?',
          a: 'We currently serve our customers in Saudi Arabia, the UAE, Kuwait, Bahrain, Oman, the USA, and the UK through our website. For assistance, please contact us via WhatsApp: [+966920000689].',
        },
        {
          q: 'How do I know if my order has been shipped?',
          a: 'Once your order has been shipped, you will receive a tracking number via email. You can also check your order status from your account dashboard on our website.',
        },
        {
          q: 'When will my order be shipped?',
          a: 'Orders are usually processed within a maximum of 2 business days from the date of purchase.',
        },
        {
          q: 'How can I track my order?',
          a: 'Once your shipment is handed over to the courier, your tracking number will be sent to you automatically.',
        },
        {
          q: 'What is the delivery time?',
          a: [
            'Within Saudi Arabia: 3 to 5 business days.',
            'Gulf countries: 5 to 10 business days.',
          ],
          note: 'Please note: During official holidays or peak seasons, delivery times may be affected by courier delays beyond our control. We appreciate your understanding and are always happy to serve you.'
        },
      ],
    },
    {
      title: 'Warranty & Maintenance',
      questions: [
        {
          q: 'What is the warranty period?',
          // a: `Two years from the date of purchase, and to learn more about the warranty please see the warranty policy ${window.location.origin}/policy`,
          a: `All electrical devices come with a two-year warranty from the date of purchase. You can review the full warranty details in our Warranty Policy.`,
        },
        {
          q: 'Can I repair products that are out of warranty?',
          a: 'Yes, our service center provides maintenance for all devices. You can reach us via our Contact Page: https://camelstep.com/en/contact , by email: Maintenance@Camelstep.com, or via WhatsApp: [+966920000689].',
        },
      ],
    },
    {
      title: 'Orders',
      questions: [
        {
          q: 'The product is currently unavailable. Can you let me know when it becomes available?',
          a: 'Or you can contact us via WhatsApp: [+966920000689] and we will be happy to let you know.',
        },
        {
          q: 'Can I cancel my order?',
          a: 'Yes, you can cancel your order if it has not yet been handed over to the courier, with no extra fees. The refund will be issued to your card or as store credit to your account.',
        },
        {
          q: 'Can I modify my order?',
          a: 'If your order is still under processing, we can assist with modifications. Please contact us via WhatsApp: [+966920000689].',
        },
        {
          q: 'I received the wrong order. What should I do?',
          a: 'We apologize for the mistake. Please contact us via WhatsApp, and we will resolve the issue within a maximum of 24 hours.',
        },
        {
          q: 'Can I return or exchange a product?',
          a: 'Yes, you can return a product if it’s in its original condition. Please review our Return Policy. Exchange service is not available. Please contact us via WhatsApp to proceed.',
        },
      ],
    },
    {
      title: 'Payment',
      questions: [
        {
          q: 'What payment methods are available?',
          a: 'We accept: Mada cards, Visa, MasterCard (including prepaid cards), and Apple Pay (including American Express).',
        },
        {
          q: 'Can I pay with American Express?',
          a: 'Yes, through Apple Pay only.',
        },
        {
          q: 'Is Cash on Delivery available?',
          a: 'Unfortunately, this service is currently unavailable',
        },
      ],
    },
    {
      title: 'General Inquiries',
      questions: [
        {
          q: 'I want to collaborate with Camel Step. How can I start?',
          a: 'We’d be happy to partner with you. Please fill out the following form, and we will contact you: https://camelstep.com/en/contact',
        },
        {
          q: 'I want to learn more about specialty coffee.',
          a: 'Specialty coffee is a unique journey from the farm to your perfect cup. To learn more, visit the Camel Step Blog https://camelstep.com/en/blogs , where we share rich content on coffee origins, processing methods, and brewing techniques. You can also watch our documentaries on YouTube to explore the coffee story from farms around the world.',
        },
        {
          q: 'Are the training programs certified?',
          a: 'Yes, all training programs are delivered by certified trainers with expertise in specialty coffee. We offer a professional learning experience with interactive tests to assess your level and help you choose the right program. Start now by visiting our Training Programs page: camelstep.com/ar/quiz',
        },
        {
          q: 'Can I add credit to my account or send a gift to a friend?',
          a: 'Currently, you cannot add direct credit to your account, but you can easily send a gift to a friend by selecting the gift option during checkout. Simply add the recipient’s mobile number, and we’ll ensure the gift is delivered beautifully. For assistance, please contact us via WhatsApp.',
        },
        {
          q: 'Do you offer coffee grinding services?',
          a: 'Yes, if you purchase coffee from our branch or online store, you can visit any of our branches and request grinding, provided the product is unopened.',
        },
      ],
    },
    {
      title: 'In-store Pickup',
      questions: [
        {
          q: 'What is the in-store pickup service?',
          a: 'You can place an order on our website and pick it up from one of our branches if you select the pickup option during checkout.',
        },
        {
          q: 'How long will you hold my order at the branch?',
          a: 'We will hold your order for 5 days from the readiness date. After that, it will be automatically canceled.',
        },
        {
          q: 'How do I know my order is ready? What do I need to bring?',
          a: 'You will receive an SMS or email with the readiness notification and branch location. When picking up, please show the readiness notification to our staff.',
        },
        {
          q: 'Can I change my delivery method from shipping to in-store pickup?',
          a: 'Yes, if the order is still under processing, our team can assist you with changing the delivery method. Please contact us via WhatsApp, and we will be happy to assist as soon as possible.',
        },
      ],
    },
  ],
  ar: [
    {
      title: 'الشحن والتوصيل',
      questions: [
        {
          q: 'هل يمكن الطلب من الفروع  عبر تطبيقات التوصيل',
          a: 'نعم، يمكن الطلب مباشرة عبر التطبيقات التالية: جاهز، ذا شفز.',
        },
        {
          q: 'هل الشحن متاح خارج السعودية؟',
          a: 'نخدم حالياً عملائنا في السعودية، الإمارات,الكويت، البحرين، وعُمان وأمريكا وبريطانيا عبر موقعنا الإلكتروني.، يرجى التواصل معنا عبر واتساب: [966920000689+].',
        },
        {
          q: 'كيف أعرف إذا تم شحن طلبي؟',
          a: 'عند شحن طلبك، سيصلك رقم التتبع عبر البريد الإلكتروني كما يمكنك متابعة حالة طلبك من لوحة التحكم في حسابك بالموقع الإلكتروني.',
        },
        {
          q: 'متى يتم شحن الطلب؟',
          a: 'عادةً يتم تجهيز الطلب خلال يومي عمل كحد أقصى من تاريخ الشراء.',
        },
        {
          q: 'كيف اتابع طلبي؟',
          a: 'بمجرد تسليم الشحنة لشركة النقل، يتم إرسال رقم التتبع تلقائيًا لك.',
        },
        {
          q: 'ما هي مدة التوصيل؟',
          a: [
            'داخل السعودية: من 3 إلى 5 أيام عمل.',
            'دول الخليج: من 5 إلى 10 أيام عمل.',
          ],
          note: 'يرجى ملاحظة أنه في أوقات الإجازات الرسمية أو المواسم العالية، قد يطرأ تأخير على الشحن من قبل شركات التوصيل، وهو خارج عن إرادتنا. نقدر تفهمك ونسعد بخدمتك دائمًا.'
        },
      ],
    },
    {
      title: 'الضمان والصيانة',
      questions: [
        {
          q: 'ما مدة الضمان؟',
          // a: `سنتين من تاريخ الشراء، ولمعرفة المزيد حول الضمان الرجاء الإطلاع على سياسة الضمان ${window.location.origin}/policy`,
          a: `جميع الأجهزة الكهربائية مشمولة بضمان لمدة سنتين من تاريخ الشراء.يمكنك الإطلاع على تفاصيل الضمان من خلال سياسة الضمان.`,
        },
        {
          q: 'هل يمكن إصلاح الأجهزة الخارجة عن الضمان؟',
          a: 'نعم، مركز الصيانة لدينا يقدم خدماته لجميع الأجهزة. نسعد بتواصلكم معنا من خلال صفحة التواصل عبر الرابط التالي https://camelstep.com/ar/contact ، أو من خلال البريد  الإلكتروني Maintenance@Camelstep.com، أو عبر الواتساب: [966920000689+]',
        },
      ],
    }, {
      title: 'الطلبات',
      questions: [
        {
          q: 'المنتج غير متوفر، هل يمكن تنبيهي؟',
          a: 'بكل سرور في حال رغبتكم الرجاء التواصل معنا عبر واتساب: [966920000689+] ليتم أشعارك عند توفره.',
        },
        {
          q: 'هل يمكن إلغاء الطلب؟',
          a: 'نعم، يمكنك إلغاء طلبك في حال لم يُسلَّم لشركة الشحن، دون رسوم. و سيُعاد المبلغ إلى بطاقتك أو كرصيد في حسابك بالموقع،نسعد بتواصلك معنا',
        },
        {
          q: 'هل يمكن التعديل على الطلب؟',
          a: 'إذا كان الطلب لا يزال تحت المعالجة، يمكننا مساعدتك في التعديل. عن طريق التواصل معنا عبر واتساب: [966920000689+].',
        },
        {
          q: 'استلمت طلبًا غير صحيح، ماذا يجب أن أفعل؟',
          a: 'نعتذر عن هذا الخطأ، نسعد بتواصلك معنا عبر الواتساب، وسنقوم بخدمتك ومعالجة المشكلة خلال 24 ساعة كحد أقصى.',
        },
        {
          q: 'هل يمكنني استرجاع أو استبدال المنتج؟',
          a: 'نعم، يمكنك استرجاع المنتج بشرط أن يكون بحالته الأصلية. الرجاء الاطلاع على سياسة الاسترجاع خدمة الاستبدال غير متوفرة، يُرجى التواصل معنا عبر واتساب لإكمال الإجراءات.',
        },
        // {
        //   q: ' استلمت منتج وارغب باسترجاعه؟',
        //   a: 'يؤسفنا أن المنتج لم يرضيك، يمكن العمل على استرجاع المنتج إذا كان في حالته الأصلية نرجو التواصل معنا عبر الواتساب 966920000689',
        // },
      ],
    }, {
      title: 'الدفع',
      questions: [
        {
          q: 'ما طرق الدفع المتاحة؟',
          a: 'نقبل: بطاقات مدى -  فيزا وماستركارد (بما في ذلك مسبقة الدفع)  - Apple Pay (بما فيها بطاقات American Express)',
        },
        {
          q: 'هل يمكن الدفع بـ American Express؟',
          a: 'نعم عبر Apple Pay فقط.',
        },
        {
          q: 'هل الدفع عند الاستلام متوفر؟',
          a: 'نعتذر، هذه الخدمة غير متوفرة حالياً.',
        },
      ],
    }, {
      title: 'استفسارات عامة',
      questions: [
        {
          q: 'أرغب بالتعاون التجاري مع خطوة جمل، كيف أبدأ؟',
          a: 'نسعد بشراكتك قم بتعبئة النموذج التالي وسيتم التواصل معك:رابط التسجيل: https://camelstep.com/ar/contact',
        },
        {
          q: 'أرغب بمعرفة المزيد عن القهوة المختصة؟',
          a: 'لقهوة المختصة رحلة فريدة تبدأ من المزرعة وتنتهي بفنجان متقن يروي التفاصيل. لمعرفة المزيد، ندعوك لزيارة مدونة خطوة جمل  https://camelstep.com/ar/blogs حيث نوفر محتوى غني عن أصول القهوة، طرق المعالجة، والتحضير. كما يمكنك مشاهدة أفلامنا الوثائقية على يوتيوب لتتعرف على قصة القهوة من قلب المزارع حول العالم.',
        },
        {
          q: 'هل البرامج التعليمية معتمدة؟',
          a: 'نعم، جميع البرامج التعليمية تُقدَّم عبر مدربين معتمدين وذوي خبرة في مجال القهوة المختصة. نوفر لك تجربة تعليمية احترافية تشمل اختبارات تفاعلية لتقييم مستواك واختيار البرنامج المناسب لك. يمكنك البدء الآن عبر زيارة صفحة البرامج التعليمية على موقعنا: camelstep.com/ar/quiz',
        },
        {
          q: 'هل يمكنني شحن رصيد لحسابي أو إهداء صديق؟',
          a: 'حاليًا لا يمكن شحن رصيد مباشر للحساب، ولكن يمكنك إرسال هدية لصديق بسهولة من خلال خانة الإهداء أثناء إتمام الطلب، فقط أضف رقم جوال العميل المُهدى له وسنتولى إيصال الهدية بالشكل المناسب. للمساعدة أو الاستفسار عن الخيارات المتاحة، يسعدنا خدمتك عبر واتساب.',
        },
        {
          q: 'هل تقدمون خدمة طحن البن؟',
          a: 'نعم في حال شرائك من الفرع و الموقع الالكتروني يمكنك التوجه إلى إحدى فروعنا وطلب طحنه بشرط أن يكون المنتج مغلقا ولا يتم فتحه.',
        },
      ],
    }, {
      title: 'الاستلام من الفروع',
      questions: [
        {
          q: 'ما هي خدمة الاستلام من الفرع؟',
          a: 'إمكانك الطلب من الموقع واستلام الطلب من أحد فروعنا مباشرة، في حال اختيارك للفرع المتاح للإستلام عند طلبك من خلال الموقع.',
        },
        {
          q: 'كم مدة الاحتفاظ بالطلب في الفرع؟',
          a: 'نحتفظ بالطلب لمدة 5 أيام من تاريخ الجاهزية، وبعدها يُلغى تلقائيًا.',
        },
        {
          q: 'كيف أعرف أن طلبي جاهز؟ وما هو المطلوب عند الاستلام؟',
          a: 'ستصلك رسالة نصية أو بريد إلكتروني بإشعار الجاهزية وموقع الفرع. عند الاستلام، يرجى إظهار إشعار الجاهزية للموظف.',
        },
        {
          q: 'في حال رغبتي في تغيير حالة الطلب من توصيل الى الاستلام من الفرع، هل يمكن التعديل؟',
          a: 'نعم، إذا كان الطلب لا يزال تحت المعالجة. يمكن لممثلنا مساعدتك في تغيير ذلك حسب رغبتك الرجاء التواصل معنا عبر واتساب وسنقوم بخدمتك في أقرب وقت ممكن.',
        },
      ],
    },
  ],
};
